import type { IModalContent } from 'core-components/library/modalDialog/models/IModalContent'

import {
  AcknowledgmentStatusPanel,
  type AcknowledgmentStatusPanelProps,
} from './AcknowledgmentStatusPanel'

type AcknowledgmentStatusDialogContentProps = IModalContent &
  AcknowledgmentStatusPanelProps & {
    onClose: () => void
  }

/**
 * `ModalDialog`'s content slot. The acknowledgment itself lives in the panel, which the dialog and
 * the cockpit's attention-statuses tile share; the modal's own props are read by neither.
 */
export const AcknowledgmentStatusDialogContent = (
  props: AcknowledgmentStatusDialogContentProps
) => <AcknowledgmentStatusPanel {...props} />
